import { getSupabase } from "@/shared/api/supabase";
import { VisitSchema, type Visit } from "@/shared/lib/db-schema";

export interface VisitInput {
  tg_id: number;
  path: string;
  user_agent: string;
  referer: string;
}

export async function recordVisit(input: Partial<VisitInput> = {}): Promise<void> {
  const payload: Visit = VisitSchema.parse({
    tg_id: input.tg_id ?? 0,
    path: input.path ?? (typeof location !== "undefined" ? location.pathname : ""),
    user_agent: input.user_agent ?? (typeof navigator !== "undefined" ? navigator.userAgent : ""),
    referer: input.referer ?? (typeof document !== "undefined" ? document.referrer : ""),
  });
  try {
    await getSupabase().functions.invoke("visit", { method: "POST", body: payload });
  } catch (e) {
    if (import.meta.env.DEV) console.warn("[visit] recordVisit failed:", e);
  }
}
